<template>
<div  class="pt-5" style="background-color: #d5d5d5">

	<div class="position-fixed" style="top: 62px; z-index: 2;" >
			<b-button-group class="about-us-btn-group m-2" style="opacity: 0.9;">
				<b-button variant="light" href="#top">Team</b-button>
				<b-button variant="light" href="#board-of-advisors">Board of Advisors</b-button>
				<b-button variant="light" href="#partners">Partners</b-button>
			</b-button-group>
		</div>

  <b-container>
    <!--b-row class="mt-5 mb-3">
      <b-col style="text-align: center">
	
        <h3 style="color: #2e145e">We have
	  <button class="border-0 bg-transparent p-0" style="color: red;">
            <span v-b-toggle.accordion-savvy accordion="accordion" style="font-weight: 500;">Construction Savvy	    
	      <font-awesome-icon
		size="xs"
		:icon="iconCaretDown"
		
		/>	    
	    </span>
	  </button>
	  &nbsp;and Solid
          <button class="border-0 bg-transparent p-0" style="color: red;">
            <span v-b-toggle.accordion-solid accordion="accordion" style="font-weight: 500;">Linked Data
	      <font-awesome-icon
		size="xs"
		:icon="iconCaretDown"
		
		/>
	    </span>
	  </button>
	  &nbsp;experience
        </h3>
	
        <b-collapse id="accordion-savvy" visible accordion="accordion" style="text-align: left">
      	  <br>
      	  <b-jumbotron class="mx-1 mb-0 p-3" style="background-color: #f8f9fa6b">
            <template slot="lead">
              <b>We know the complicated problems of construction because we've lived them, from the owner's requirements through design and procurement to construction and operations.  We focus only on solutions that actually work.</b>
            </template>
      	  </b-jumbotron>
        </b-collapse>
	
        <b-collapse id="accordion-solid" accordion="accordion" style="text-align: left">
          <b-jumbotron class="mx-1 mb-0 p-3" style="background-color: #f8f9fa6b">
            <template slot="lead">
              <b>After years of experience working with semantic technology in the very diverse construction industry, we created a new kind of AI able to link dozens of siloed conceptual hierarchies (ontologies) together with our own ontology. This AI finally 'understands' how to give you the actionable information you need when you need it.</b>
            </template>
          </b-jumbotron>
        </b-collapse>
	
      </b-col>
    </b-row-->


    <b-row class="mt-5 mb-3">
      <b-col v-for="person in leaders"
	     :key="person.name"
	     md="12" lg="6">
				<b-row class="py-4">
					<b-col sm="4">
						<img src="../assets/about_fcg.png" class="person-thumbnail" :alt="person.name + ' image'" v-if="person.name === 'Frederick Gibson'"/>
						<img src="../assets/about_kg.png" class="person-thumbnail" :alt="person.name + ' image'" v-if="person.name === 'Kai Gilb'"/>
						<img src="../assets/about_rp.png" class="person-thumbnail" :alt="person.name + ' image'" v-if="person.name === 'Roger Perry'"/>
						<img src="../assets/about_lm.png" class="person-thumbnail" :alt="person.name + ' image'" v-if="person.name === 'Lenin Mangoba'"/>
						<img src="../assets/about_tr.png" class="person-thumbnail" :alt="person.name + ' image'" v-if="person.name === 'Theresa Rogers'"/>
						<img src="../assets/about_trinity.gif" class="person-thumbnail" :alt="person.name + ' image'" v-if="person.name === 'Trinity'"/>
					</b-col>
					<b-col sm="8">
						<b-row class="ml-1">
							<h3 style="color: #2e145e"> {{ person.name }} </h3>
							<span class="mt-2">
					<a class="mx-1" :href="person.link" target="_blank">
						<font-awesome-icon :icon="iconLinkedin" />
					</a>
					<a class="mx-1" :href="person.email">
						<font-awesome-icon :icon="iconEnvelope" />
					</a>
							</span>
						</b-row>
						<b-row class="ml-1">
							<b-col class="pl-0"><b-row><b-col xs="12"><h5> {{ person.title }} </h5></b-col></b-row>
					<b-row><b-col xs="12"><p>{{ person.bio }} </p></b-col></b-row></b-col>
						</b-row>
					</b-col>
				</b-row>
      </b-col>
    </b-row>

		<div id="board-of-advisors" style="height: 96px;"></div>
    
    <b-row class="my-3">
      <b-col style="text-align: center">
				<h1>Board of Advisors</h1>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="6" md="3" class="p-4" :key="person" v-for="person in board">
				<b-row class="text-center">
					<img src="./../assets/about_tg.png" class="person-thumbnail" :alt="person.name + ' image'" v-if="person.name === 'Tom Gilb'"/>
					<img src="./../assets/about_jl.png" class="person-thumbnail" :alt="person.name + ' image'" v-if="person.name === 'Joseph Levi'"/>
					<img src="./../assets/about_jg.png" class="person-thumbnail" :alt="person.name + ' image'" v-if="person.name === 'John Goecke'"/>
					<img src="./../assets/about_ja.png" class="person-thumbnail" :alt="person.name + ' image'" v-if="person.name === 'Jans Aasman'"/>
					<img src="./../assets/about_mp.png" class="person-thumbnail" :alt="person.name + ' image'" v-if="person.name === 'Mike Payne'"/>
				</b-row>
	
				<b-row>
					<h3 style="color: #2e145e; font-size: 22px"> {{ person.name }} </h3>
					<div class="mt-1">
						<a class="mx-1" :href="person.link" target="_blank">
							<font-awesome-icon :icon="iconLinkedin" />
						</a>
					</div>
				</b-row>
	
				<b-row><h5> {{ person.title }} </h5></b-row>

				<b-row v-b-toggle="person.name + 'collapse-bio'"><span class="text-primary" style="font-style: italic">More info ></span></b-row>

				<b-collapse :id="person.name + 'collapse-bio'">
					<b-row><p>{{ person.bio }} </p></b-row>
				</b-collapse>

      </b-col>
    </b-row>

		<div id="partners" style="height: 62px;"></div>

		<b-row class="my-3">
			<b-col style="text-align: center">
				<h1>Partners</h1>
			</b-col>
		</b-row>

		<b-row class="text-center pb-5">
			<b-col class="d-flex">
				<b-link to="/Aconex" class="m-auto" style="color: #585aff;" @click.native="scrollToTop()">
					<img src="./../assets/oracle-partner-600px.png" class="person-thumbnail" alt="Oracle Partner logo" />
					<p class="my-2">https://graphmetrix.com/Aconex</p>
				</b-link>
			</b-col>
			<b-col class="d-flex">
				<b-link href="https://www.i4technology.no" class="m-auto" style="color: #585aff;" target="_blank">
					<img src="./../assets/i4technology-logo.png" class="person-thumbnail" alt="i4 Technology logo" />
					<p class="my-2">https://www.i4technology.no</p>
				</b-link>
			</b-col>
			<b-col class="d-flex">
				<b-link href="https://cybersapien.ai" class="m-auto" style="color: #585aff;" target="_blank">
					<img src="./../assets/cybersapian.png" class="person-thumbnail" alt="CyberSapien logo" />
					<p class="my-2">https://cybersapien.ai</p>
				</b-link>
			</b-col>
		</b-row>

    <b-row>
      <b-col>
				<div class="py-5 d-flex">
					<p class="mx-auto">
						Graphmetrix, Inc<br>
						1255 Treat Blvd. Suite 300<br>
						PMB#4611<br>
						Walnut Creek, CA 94597
					</p>
				</div>
      </b-col>
    </b-row>
  </b-container>
</div>
</template>

<script>
const $ = require('jquery')
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons';
import * as log from 'loglevel'
export default {
    name: 'aboutTree',
    components: {
			FontAwesomeIcon
    },
    data () {
			return {
				iconCaretDown: faCaretDown,
	    	iconCaretUp: faCaretUp,
				iconLinkedin: faLinkedin,
  	    iconEnvelope: faEnvelope,
			}
    },
    computed: {
	leaders() {
	    return this.$store.state.leaders;
	},
	board() {
    	    return this.$store.state.board;
	}
    },
    methods: {
	/*img: function (image) {
	    require(image)
	},*/
	/*caretActive: function () {
	    if ( $('.show') ) {
		return 'caret-active'
	    }
	},*/
	scrollToTop: function () {
			window.scrollTo(0,0);
	},
	/*personImage: function(person) {
		var imgUrl;
		switch (person) {
			case (person === 'Frederick Gibson'):
				return imgFred;
				break
				case (person === 'Kai Gilb'):
				return imgKai;
				break
			default:
				return imgFred;
		}
	}*/
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.about-us-btn-group > button {
	color: #343a40 !important;
}
.caret-active {
    transform: rotateX(180deg);
}
.person-thumbnail {
	height: 150px;
}
</style>
